import { render, staticRenderFns } from "./NewImages.vue?vue&type=template&id=6113ba8d&scoped=true&"
import script from "./NewImages.vue?vue&type=script&lang=js&"
export * from "./NewImages.vue?vue&type=script&lang=js&"
import style0 from "./NewImages.vue?vue&type=style&index=0&id=6113ba8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6113ba8d",
  null
  
)

export default component.exports